import styled from 'styled-components';
import { colors } from '@omilia/theme';

export const SWarningText = styled.span`
  color: ${colors.COLOR_RED_600};
  font-weight: 600;
`;

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
